import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/bell-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M634 471c6.9 5.5 8 15.6 2.5 22.5l-10 12.5c-5.5 6.9-15.6 8-22.5 2.5l-598-467.5c-6.9-5.5-8-15.6-2.5-22.5l10-12.5c5.5-6.9 15.6-8 22.5-2.5zM163.5 368h182.8l61.4 48h-279.7c-19.1 0-32-15.6-32.1-32 0-7.5 2.6-15.3 8.6-21.7 18.4-19.7 51.6-49.7 54.8-140.4l45.5 35.5c-6.9 54.8-24.7 88.5-41.4 110.6zM320 96c-23.3 0-45 7.2-62.9 19.4l-38.2-29.8c19.7-15.8 43.1-27.3 69.1-32.7v-20.8c0-17.7 14.3-32 32-32s32 14.3 32 32v20.8c73.5 15.3 127.9 77.5 127.9 155.2 0 41.4 6 70.7 14.3 92.8l-59.5-46.5c-1.6-14-2.8-28.9-2.8-45.7 0-0.2 0.1-0.4 0.1-0.6 0-61.9-50.1-112-112-112zM320 512c-35.3 0-64-28.7-64-64h127.9c0 35.3-28.6 64-64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/bell-slash.js
// module id = 1693
// module chunks = 0